
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/select-property",
      function () {
        return require("private-next-pages/select-property/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/select-property"])
      });
    }
  